import React, { Fragment, useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button, Col, Form, Label, Row,} from "reactstrap"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import APIS from "../../apis"
import { withTranslation } from "react-i18next"
import Select from "react-select"

const AddFicheVoeuxSurveillance = props => {
  var userAuthEnseignant = JSON.parse(
    localStorage.getItem("userAuthEnseignant")
  )
  var enseignant_id = userAuthEnseignant.user.enseignant_id
  var departement_id =userAuthEnseignant.user.departement_id
  var annee_id =userAuthEnseignant.user.annee_id
  const [periode, setPeriode] = useState([])
  const [selectPeriode, setSelectPeriode] = useState("")
  const [etat, setEtat] = useState(0)
  const [semestre, setSemestre] = useState([
    {value: 1, label: "Semestre 1", section: 0},
    {value: 2, label: "Semestre 2", section: 1},
    {value: 3, label: "Session Contrôle ", section: 2},
  ])
  const [selectSemestre, setSelectSemestre] = useState("")


  const save = async () => {
    var etat = true
    if(selectSemestre === ""){
      etat = false
      toast.error("⛔ Semestre obligatoire", {
        containerId: "A",
      })
    }else if (selectPeriode === "") {
      etat=false
      toast.error("⛔ Période obligatoire", {
        containerId: "A",
      })
    }
    if (etat) {
      const res = await APIS.post("fichesurveillance/store", {
        semestre_id: selectSemestre.value,
        departement_id:departement_id,
        enseignant_id:enseignant_id,
        annee_id:annee_id,
        periode: selectPeriode.value,
      })
      if (res.data.msg === "Fiche voeux ajouté avec succes") {
        toast.success(" Votre fiche de voeux est ajouté avec succées ", {
          containerId: "A",
        })
        props.setSection(1)
      }
    }
  }
  const getPeriode = async event => {
    setSelectSemestre(event)
    setSelectPeriode("")
    const res = await APIS.post(
      "fichesurveillance/get_periodes",
      {
        semestre_id: event.value,
        annee_id: annee_id
      }
    ).then(res => {
      setPeriode(res.data.periodes)
    })
    const resEtat = await APIS.post(
      "ParametrageSurveillanceExamen/verif_activ",
      {
        semestre_id: event.value,
        annee_id: annee_id
      }
    ).then(resEtat => {
      setEtat(resEtat.data.active)
    })
  }
  return (
    <React.Fragment>
      <Row>
        <Form>
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">
                  {props.t("Semestre")} :
                </Label>
                <Select
                    options={semestre}
                    isSearchable={true}
                    onChange={e => getPeriode(e)}
                />
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">
                  {props.t("Périodes")} :
                </Label>
                <Select
                    options={periode}
                    isSearchable={true}
                    onChange={e => setSelectPeriode(e)}
                    value={selectPeriode}
                />
              </div>
            </Col>

          </Row>

          <div style={{display: "flex", justifyContent: "center"}}>
            {" "}
            <Col lg="6">
              <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                  className="text-center mt-4"
              >
                <Button
                    type="button"
                    color="warning"
                    className="btn btn-warning  mb-2 me-2"
                    onClick={props.back}
                >
                  {props.t("Annuler")}
                </Button>
              </div>
            </Col>

              <Col lg="6">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                  className="text-center mt-4"
                >
                  {etat === 1 ? (
                  <button
                    type="button"
                    className="btn btn-primary "
                    onClick={save}
                  >
                    {props.t("Confirmer")}
                  </button>
                  ):null}
                </div>
              </Col>


          </div>

        </Form>
      </Row>
      <ToastContainer
          transition={Slide}
          enableMultiContainer
          containerId={"A"}
          position={toast.POSITION.TOP_RIGHT}
          autoClose={2500}
      />
    </React.Fragment>
  )
}

export default withTranslation()(AddFicheVoeuxSurveillance)
AddFicheVoeuxSurveillance.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}
